var _XYloadJS = function (params) {
  var head = document.getElementsByTagName("head")[0];
  var script = document.createElement('script');
  script.onload = script.onreadystatechange = script.onerror = function () {
    if (script && script.readyState && /^(?!(?:loaded|complete)$)/.test(script.readyState)) return;
    script.onload = script.onreadystatechange = script.onerror = null;
    script.src = '';
    script.parentNode.removeChild(script);
    script = null;
    if (params.callback) params.callback()
  };
  script.charset = params.charset || document.charset || document.characterSet || 'utf-8';
  script.src = params.src;
  try {
    head.appendChild(script)
  } catch (exp) {
  }
};
var hostUrl = document.location.href;
var domainName = 'http://';
if(hostUrl.split(':')[0] == 'https'){
  domainName = 'https://'
}else{
  domainName = 'http://'
}
var jQueryLoaded = typeof jQuery != "undefined";
if (!jQueryLoaded) _XYloadJS({src: domainName + 'ishow.cctv.com/js/jquery-1.8.0.min.js'});
var _XYVideoPlayer = null;
(function ($) {
  $.fn.xyPlayer = function (options, callback) {
    var defaults = {
      id: '',
      item_id: '',
      width: 640,
      height: 385,
      type: 'out',
      autoplay: true,
      order: 'asc',
      version: '3.096',
      controls: true,
      static_url: domainName + 'ishow.cctv.com/',
      configxml: 'player.xml',
      pid: '100',
      time: 0,
      extend: true,
      skin: 'default',
      lang: 'zh-CN',
      params: '',
      list_url: '',
      callback: false,
      hideRelationlist: false,
      playrelationlist: false
    };
    var $base = this;
    var $video;
    options = $.extend(true, defaults, options);
    if (callback) {
      options.callback = callback
    }
    this.init = function () {
      // if (isIOS()) {
        if (!jQuery().bxPlayer) {
          $.getScript(options.static_url + 'js/jquery.bxPlayer.js?ver=' + options.version, function () {
            $video = loadBxPlayer()
          })
        } else {
          $video = loadBxPlayer()
        }
      // } else {
      //   if (!jQuery().flash) {
      //     $.getScript(options.static_url + 'js/jquery.swfobject.min.js?ver=' + options.version, function () {
      //       $video = loadFlashPlayer()
      //     })
      //   } else {
      //     $video = loadFlashPlayer()
      //   }
      // }
      return
    };
    this.play = function () {
      try {
        return $video.play()
      } catch (e) {
        return false
      }
    };
    this.pause = function () {
      try {
        return $video.pause()
      } catch (e) {
        return false
      }
    };
    this.getData = function () {
      if (isIOS()) {
        return $video.getData()
      } else {
        var data = $video.getVideoData().replace(/\"\=\"/gi, "\":\"").replace(/\'/gi, "\\'");
        return eval('(' + data + ')')
      }
    };
    this.getStats = function () {
      try {
        return $video.getStats()
      } catch (e) {
        return false
      }
    };
    this.getPlaylist = function () {
      try {
        return $video.getPlaylist()
      } catch (e) {
        return null
      }
    };
    this.changeVideo = function (id) {
      if (isIOS()) {
        return $video.changeVideo(id)
      } else {
        return $video.changeVideoByJS(id)
      }
    };
    this.changeVideo = function (id, time) {
      if (isIOS()) {
        return $video.changeVideo(id)
      } else {
        return $video.changeVideoByJS(id, time)
      }
    };
    this.setAutoPlaylist = function (bool) {
      if (isIOS()) {
        $video.setListAutoPlay(bool)
      } else {
        $video.setListAutoPlay(bool)
      }
    };
    this.getTime = function () {
      if (isIOS()) {
        return 0
      } else {
        return $video.getTime()
      }
    };
    this.getVideoId = function () {
      try {
        return this.getData().videoId
      } catch (e) {
        return null
      }
    };
    this.isLoaded = function () {
      if (isIOS()) {
        return ($video.getStats().code == 200)
      } else {
        return ($video.PercentLoaded() == 100)
      }
    };
    this.resize = function (w, h) {
      if (isIOS()) {
        $video.resize(w, (h - 25))
      } else {
        $('#__XYFlashPlayer__').attr({'width': w, 'height': h})
      }
      return
    };
    this.isPlay = function () {
      try {
        return $video.isPlay()
      } catch (e) {
        return null
      }
    };
    this.getTime = function () {
      try {
        return $video.getTime()
      } catch (e) {
        return null
      }
    };
    this.seek = function (time) {
      try {
        return $video.seek(time)
      } catch (e) {
        return null
      }
    };
    this.getStaticData = function () {
      var xiyouplayTraceerImg = document.getElementById("xiyouplayTraceerImg");
      xiyouplayTraceerImg.src = $video.getStaticData() + "&rand=" + Math.random()
    };
    this.snsPostData = function () {
      try {
        return $video.snsPostData()
      } catch (e) {
        return null
      }
    };

    function isIOS() {
      return /(iphone|ipad|ipod|ios|android)/i.test(navigator.userAgent)
    }

    function loadBxPlayer() {
      $base.empty();
      return $base.bxPlayer({
        id: options.id,
        pid: options.pid,
        width: options.width,
        height: options.height,
        type: options.type,
        item_id: options.item_id,
        order: options.order,
        skin: options.skin,
        lang: options.lang,
        params: options.params,
        autoplay: options.autoplay,
        controls: options.controls,
        callback: options.callback,
        use_hls: options.use_hls
      })
    }

    function loadFlashPlayer() {
      if (options.list_url != '') {
        options.list_url = encodeURIComponent(options.list_url)
      }
      $base.flash({
        id: '__XYFlashPlayer__',
        swf: options.static_url + 'flash/player.swf?ver=' + options.version,
        flashvars: {
          id: options.id,
          item_id: options.item_id,
          pid: options.pid,
          type: options.type,
          order: options.order,
          skin: options.skin,
          lang: options.lang,
          params: options.params,
          autoplay: options.autoplay,
          list_url: options.list_url,
          time: options.time,
          hideRelationlist: options.hideRelationlist,
          playrelationlist: options.playrelationlist,
          extend: options.extend,
          config: options.static_url + 'flash/' + options.configxml + '?ver=' + options.version
        },
        alternative: true,
        width: options.width,
        height: options.height,
        wmode: 'opaque',
        menu: false,
        quality: 'best',
        allowFullScreen: true,
        allowScriptAccess: 'always',
        hasVersion: 10,
        expressInstall: options.static_url + 'flash/expressInstall.swf?ver=' + options.version
      });
      return $('#__XYFlashPlayer__').get(0)
    }

    return this.each(function () {
      $base.init()
    });
    return this
  }
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./static/lib/xiyou.player.js
// module id = CZzb
// module chunks = 0